module.exports = __webpack_public_path__ + "img/WP2023-logo-main.b21a3aba.png";